import { CollectionPreferences } from '@amzn/awsui-components-react';

import { localization, PAGE_SIZE_OPTIONS } from './constants';
import { buildVisibleContentOption } from './helper';
import { Preference, VisibleContentOption } from './types';

interface PreferenceProps {
    preferences: Preference,
    setPreferences: (preference: any) => void,
    disabled?: boolean,
    visibleContentOptions?: VisibleContentOption[];
}

const Preferences = (props: PreferenceProps): JSX.Element => {
    const visibleContentOption = buildVisibleContentOption(props.visibleContentOptions);
    return (
        <CollectionPreferences
            title={localization.PREFERENCE_HEADER}
            confirmLabel={localization.CONFIRM_BUTTON_TEXT}
            cancelLabel={localization.CANCEL_BUTTON_TEXT}
            disabled={props.disabled}
            preferences={props.preferences}
            onConfirm={({ detail }) => props.setPreferences(detail)}
            pageSizePreference={{
                title: localization.PAGE_SIZE_HEADER,
                options: PAGE_SIZE_OPTIONS,
            }}
            wrapLinesPreference={{
                label: localization.WRAP_LINE_LABEL,
                description: localization.WRAP_LINE_DESCRIPTION,
            }}
            visibleContentPreference={visibleContentOption}
        />
    );
};

export default Preferences;
